// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BAow","icon":"styles_icon__1V-7h"};